module.exports = __webpack_public_path__ + "static/media/pic5.84ba7b9f.jpg";